module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-card",
    class: {
      'rt-card-shadow': _vm.shadow
    },
    style: (_vm.computedStyle)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31eb3a5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/card/rtCard.vue
// module id = 2055
// module chunks = 228